/* eslint-disable sort-vars */
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import React, { Component } from 'react';

import { CHECKOUT_STEP_MAP, EDIT_ADDRESS_STEP, REVIEW_STEP } from 'constants/checkoutFlow';

import marketplace from 'cfg/marketplace.json';
import AddressListHeader from 'components/checkout/caap/address/addresslist/AddressListHeader';
import AddressListMessage from 'components/checkout/caap/address/addresslist/AddressListMessage';
import AddNewAddressDesktop from 'components/checkout/caap/address/addresslist/AddNewAddressDesktop';
import AddNewAddressMobile from 'components/checkout/caap/address/addresslist/AddNewAddressMobile';
import AddressListButtons from 'components/checkout/caap/address/addresslist/AddressListButtons';
import ShipToNewAddressSection from 'components/checkout/caap/address/addresslist/ShipToNewAddressSection';
import ModalOverlay from 'components/checkout/caap/ModalOverlay';
import SmallScreenOnly from 'components/checkout/caap/SmallScreenOnly';
import Addresses from 'components/checkout/caap/address/Address';
import BackButton from 'components/checkout/caap/BackButton';
import ListItem from 'components/checkout/caap/ListItem';
import { SmallLoader } from 'components/Loader';
import css from 'styles/components/checkout/caap/address/addressList.scss';
import {
  itemBox as styleItemBox
} from 'styles/components/checkout/caap/contentBox.scss';

export class AddressList extends Component {
  componentDidMount() {
    this.setState({ start: 0 });
  }

  goToPage = (e, page) => {
    e.preventDefault();
    this.setState({ start: (page - 1) * 6 });
  }

  nextPage = e => {
    e.preventDefault();
    const { start } = this.state;
    this.setState({ start: start + 6 });
  }

  prevPage = e => {
    e.preventDefault();
    const { start } = this.state;
    this.setState({ start: start - 6 });
  }

  render() {
    const {
      addresses,
      addressMessage,
      errorMessage,
      isBilling = false,
      isFetchingCheckoutData,
      onAddressSelected,
      onCloseModalOverlayClick,
      onDeleteAddressClick,
      onEditAddressClick,
      onUseThisAddressClick,
      pageHistory,
      purchaseId,
      purchaseBillingAddressId,
      selectedAddressId,
      shippingAddressId,
      showAsModal
    } = this.props;

    if (!addresses) {
      return <SmallLoader />;
    }

    const { state, context: { testId } } = this;
    let start = 0;
    if (state !== null) {
      ({ start } = state);
    }

    const visibleStart = start,
      visibleEnd = start + 6,
      addressType = isBilling ? 'billing' : 'shipping',
      filteredAddresses = addresses.filter(address => filterCountries(isBilling, address)),
      sectionTitleStyles = cn({ [css.titleWhenBackBtn]: pageHistory && pageHistory.includes('spc') });

    let addressSet = filteredAddresses;

    const nonAddressStyles = cn(styleItemBox, css.addNewAddressBox, css.spacer, {
      [css.inVisibleSlice]: addressSet.length >= visibleStart && addressSet.length < visibleEnd
    });

    const addNewDesktop = <li className={nonAddressStyles} key="AddAddressDesktop">
      <div className={css.listItemWrapper}>
        <AddNewAddressDesktop addressType={addressType} isBilling={isBilling} />
      </div>
    </li>;

    const spacer = <li className={nonAddressStyles} key="spacer">&nbsp;</li>;

    const numFilteredAddresses = filteredAddresses.length,
      missingOneCell = (numFilteredAddresses + 1) % 3 === 0,
      missingTwoCells = (numFilteredAddresses + 2) % 3 === 0;

    // add 'add new' link or a spacer if appropriate
    if (missingTwoCells) {
      addressSet = [...addressSet, addNewDesktop, spacer];
    } else if (missingOneCell) {
      addressSet = [...addressSet, addNewDesktop];
    }

    const numAddresses = addressSet.length,
      currentPage = start / 6 + 1,
      showPaginationBar = numFilteredAddresses > 6,
      isPrevBtnEnabled = start > 1 && numAddresses > 6,
      isNextBtnEnabled = start < numAddresses - 6 && numAddresses > 6,
      paginationPages = buildPaginationRange(currentPage, Math.ceil(numAddresses / 6)),
      prevButtonStyle = cn({ [css.disabled]: !isPrevBtnEnabled }),
      nextButtonStyle = cn({ [css.disabled]: !isNextBtnEnabled });

    return (
      <div className={css.addressListContainer}>
        <ModalOverlay onCloseModalOverlayClick={onCloseModalOverlayClick} showAsModal={showAsModal}>
          <AddressListHeader
            addressType={addressType}
            isBilling={isBilling}
            onCloseModalOverlayClick={onCloseModalOverlayClick}
            purchaseId={purchaseId}
            showAsModal={showAsModal}
          />

          {
            pageHistory && pageHistory.includes('spc')
              ? <BackButton href={CHECKOUT_STEP_MAP[REVIEW_STEP]} />
              : null
          }

          <SmallScreenOnly><h1 className={sectionTitleStyles}>Choose a {addressType} address</h1></SmallScreenOnly>
          <div className={css.contentWrapper}>

            {
              !!(addressMessage || errorMessage) && <div className={css.wrapper}>
                { errorMessage }

                <AddressListMessage addressMessage={addressMessage} />
              </div>
            }

            <ul className={css.addresses}>
              {
                addressSet.map((address, rowIndex) => {
                  if (address && address.type === 'li') {
                    return address;
                  }

                  const {
                    addressId,
                    name,
                    mailingAddress: {
                      addressLine1,
                      addressLine2,
                      city,
                      stateOrRegion,
                      postalCode,
                      countryName
                    },
                    phone: {
                      voice: {
                        primary: {
                          number: phoneNumber
                        }
                      }
                    }
                  } = address;

                  const listItemStyles = cn(
                    styleItemBox,
                    {
                      [css.selected]: (isBilling && purchaseBillingAddressId === addressId) || (!isBilling && shippingAddressId === addressId),
                      [css.first]: rowIndex === 0 && rowIndex === 0 && !addressMessage,
                      [css.inVisibleSlice]: rowIndex >= visibleStart && rowIndex < visibleEnd
                    }
                  );

                  const savedAddress = {
                    fullName: name.fullName,
                    addressLine1,
                    addressLine2,
                    city,
                    stateOrRegion,
                    postalCode,
                    phoneNumber,
                    countryName
                  };
                  return (
                    <li className={listItemStyles} key={addressId} data-test-id={testId('savedAddress')}>
                      <div className={css.listItemWrapper}>
                        <ListItem
                          itemKey={addressId}
                          index={`savedAddresses-${addressId}`}
                          onChange={() => onAddressSelected(addressId)}
                          isChecked={selectedAddressId === addressId}
                          listType="address">
                          <Addresses
                            address={savedAddress}
                            multiLineDisplay={true}
                            isSelected={selectedAddressId === addressId}>
                            {
                              isBilling
                                ? null
                                : <span className={`${css.editAddressLinkContainer} ${css.hideSmallScreen}`}>
                                  <Link
                                    data-edit-address-id={addressId}
                                    onClick={() => onEditAddressClick(addressId)}
                                    to={`${CHECKOUT_STEP_MAP[EDIT_ADDRESS_STEP]}?referrer=address&editDestinationId=${addressId}`}
                                    data-test-id={testId('editShippingAddress')}>
                                      Edit
                                  </Link>
                                </span>
                            }
                          </Addresses>
                        </ListItem>
                      </div>
                      <div className={css.buttons}>
                        <AddressListButtons
                          addressId={addressId}
                          isBilling={isBilling}
                          isFetchingCheckoutData={isFetchingCheckoutData}
                          onDeleteAddressClick={onDeleteAddressClick}
                          onEditAddressClick={onEditAddressClick}
                          onUseThisAddressClick={onUseThisAddressClick}
                          selectedAddressId={selectedAddressId}
                        />
                      </div>

                    </li>
                  );
                })
              }
            </ul>

            <AddNewAddressMobile isBilling={isBilling} />
            {
              showPaginationBar && <ul className={css.pagination} data-test-id={testId('paginationBar')}>
                <li data-test-id={testId('prevPage')} className={prevButtonStyle}>
                  {
                    isPrevBtnEnabled
                      ? <Link to="#" onClick={e => this.prevPage(e)}>&#x2190; Previous</Link>
                      : <span>&#x2190; Previous</span>
                  }
                </li>
                {
                  paginationPages.map(item => {
                    const linkClass = cn({ [css.selected]: item === currentPage });
                    if (item === '...') {
                      return (
                        <li data-test-id={testId('dots')} key="dots">...</li>
                      );
                    }
                    return (
                      <li data-test-id={testId(`page-${item}`)} key={item}>
                        <Link to="#" onClick={e => this.goToPage(e, item)} className={linkClass}>{ item }</Link>
                      </li>
                    );
                  })
                }
                <li data-test-id={testId('nextPage')} className={nextButtonStyle}>
                  {
                    isNextBtnEnabled
                      ? <Link to="#" onClick={e => this.nextPage(e)}>Next &#x2192;</Link>
                      : <span>Next &#x2192;</span>
                  }
                </li>
              </ul>
            }
            <ShipToNewAddressSection isBilling={isBilling} />
            &nbsp;
          </div>
        </ModalOverlay>
      </div>
    );
  }
}

const buildPaginationRange = (currentPage, numPages) => {
  const current = currentPage,
    last = numPages,
    delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [];

  let l;

  for (let i = 1; i <= last; i++) {
    if (i === 1 || i === last || i >= left && i < right) {
      range.push(i);
    }
  }

  for (const i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
};

const filterCountries = (isBilling, address) => {
  // for now, do not restrict selection of addresses on shipping form until
  // we add in functionality to edit billing addresses
  /* eslint-disable-next-line */
  if (true || isBilling) {
    return true;
  }
  const { mailingAddress: { countryCode } } = address;
  const { checkout: { shippingCountriesWhitelist } } = marketplace;
  return shippingCountriesWhitelist.includes(countryCode);
};

AddressList.contextTypes = {
  testId: PropTypes.func
};

export default AddressList;
